/**
 * @desc 回传跟踪到平台单
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(body: defs.walmart.WalmartOrderShippingDto, options?: any) {
  return updateResponse(
    http(URL + `/walmart/walmartOrder/createFulfillment`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
